import { i18nMark } from 'lingui-react';

const messages = {
  assetLocation: i18nMark('Asset Location'),
  noAssetLocationSubtitle: i18nMark('Try removing or editing some of your criteria to expand the search or search by city and state or zip code.'),
  noAssetLocationTitlePrefix: i18nMark('No matches for "'),
  noServiceProviderSubtitle: i18nMark('Try removing or editing some of the filters to expand your search, or search by a different location.'),
  noServiceProviderTitlePrefix: i18nMark('No results for "'),
  placeholder: i18nMark('Enter a city and state or zip code...'),
  suggestion: i18nMark('Search by asset location to see nearby providers or service provider for nearby locations.'),
  title: i18nMark('Which service provider do you want?'),
  titleSuffix: i18nMark('".'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/ServiceProviderSelectionStep/messages.js